import { render } from "./ApplicationLogo.vue?vue&type=template&id=20bbdf02"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__